import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { AppHeader } from '@/@bothrs-ui/web/components/navigation/header/AppHeader'
import { Line } from '@/@bothrs-ui/web/components/primitives/line/Line'
import { TabBar } from '@/@bothrs-ui/web/components/tab-bar/TabBar'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { globalDefinitions } from '@/defined-translations'
import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'
import { HealthProfileCategory } from '../../types/HealthProfileCategory'
import { AllergiesHealthParameterSection } from './tabs/allergies/AllergiesHealthParameterSection'
import { GeneralHealthParameterSection } from './tabs/general/GeneralHealthParameterSection'
import { MedicationHealthParameterSection } from './tabs/medication/MedicationHealthParameterSection'

const ProfileHealthPage = () => {
  const navigate = useNavigate()
  const theme = useTheme()

  const [activeTab, setActiveTab] = useState<HealthProfileCategory>(HealthProfileCategory.General)

  // Template variables
  // ------------------------------------------------------------------------- /
  const tabs = useMemo(
    () =>
      Object.values(HealthProfileCategory).map((value) => ({
        id: value,
        title: i18n._(globalDefinitions[value]),
        onClick: () => setActiveTab(value),
      })),
    [],
  )

  // Render
  // ------------------------------------------------------------------------- /

  return (
    <>
      <ContentPageLayout
        noScroll
        header={
          <AppHeader
            primaryAction={{
              label: i18n._(globalDefinitions.goBack),
              icon: ['far', 'chevron-left'],
              onClick: () => {
                navigate('/profile', { replace: true })
              },
            }}
          />
        }
      >
        <FlexColumn gap={theme.UI.Spacing.Space4} style={{ paddingBottom: theme.UI.SpacingPx.Space6 }}>
          <H3 noMargin>
            {t({
              id: 'profile.health.title',
              comment: 'Holistic health page title',
              message: 'Gezondheidsgegevens',
            })}
          </H3>

          <TabBar tabs={tabs} activeTabId={activeTab} />
          <Line />

          {activeTab === HealthProfileCategory.General ? <GeneralHealthParameterSection /> : null}

          {activeTab === HealthProfileCategory.Medication ? <MedicationHealthParameterSection /> : null}

          {activeTab === HealthProfileCategory.Allergies ? <AllergiesHealthParameterSection /> : null}
        </FlexColumn>
      </ContentPageLayout>
    </>
  )
}

export { ProfileHealthPage }
